var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTvTuvalu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_24431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#009FCA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37833 11.5031H1.78145L3.87207 12.9281L3.0752 15.2438L5.16582 13.8094L7.24707 15.2438L6.4502 12.9281L8.54082 11.5031H5.9627L5.16582 9.1875L4.37833 11.5031ZM10.8658 29.9531H8.27832L10.3689 31.3781L9.57207 33.6937L11.6627 32.2594L13.7533 33.6937L12.9471 31.3781L15.0377 29.9531H12.4689L11.6721 27.6375L10.8658 29.9531ZM4.37833 25.7719H1.78145L3.87207 27.1969L3.0752 29.5125L5.16582 28.0781L7.24707 29.5125L6.4502 27.1969L8.54082 25.7719H5.9627L5.16582 23.4562L4.37833 25.7719ZM32.2689 39.1594H29.6814L31.7814 40.575L30.9752 42.8812L33.0658 41.4563L35.1564 42.8812L34.3502 40.575L36.4502 39.1406H33.8627L33.0658 36.8344L32.2689 39.1594ZM26.4002 31.9875H28.9877L26.8971 30.5531L27.6939 28.2469L25.6033 29.6719L23.5127 28.2469L24.3189 30.5531L22.2283 31.9875H24.8064L25.6033 34.2937L26.4002 31.9875ZM18.7783 21.4406H21.3752L19.2846 20.0156L20.0814 17.7L17.9908 19.1344L15.9002 17.7L16.7064 20.0156L14.6158 21.4406H17.1939L17.9908 23.7562L18.7783 21.4406ZM12.3752 19.2562H14.9627L12.8627 17.8219L13.6689 15.5156L11.5783 16.9406L9.4877 15.5156L10.2939 17.8219L8.19395 19.2562H10.7814L11.5783 21.5625L12.3752 19.2562ZM18.7783 37.5H21.3752L19.2846 36.075L20.0627 33.75L17.9721 35.175L15.8814 33.75L16.6877 36.0656L14.5971 37.4906H17.1752L17.9721 39.8063L18.7783 37.5ZM26.4002 39.3656H28.9877L26.8971 37.9406L27.6939 35.625L25.6033 37.05L23.5127 35.625L24.3189 37.9313L22.2189 39.375H24.7971L25.5939 41.6906L26.4002 39.3656Z",
    fill: "#FFF40D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H30V22.5H60V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4844 0L45.0469 8.48438L33.6562 0H30V2.90625L41.25 11.2969L30 19.6406V22.5H33.75L45 14.1094L56.2031 22.5H60V19.6875L48.7969 11.3438L60 3V0H56.4844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.125 13.1719L30 20.625V22.5L42.7031 13.1719H40.125ZM48.75 14.1094L48.4688 15.75L57.4688 22.5H60L48.75 14.1094ZM30 0V0.140625L41.6719 8.95312L41.5781 6.89062L32.3438 0H30ZM60 0L48.7969 8.25H51.6094L60 1.96875V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7031 0V22.5H41.2031V0H48.7031ZM60 7.5V15H30V7.5H60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 9.04688V13.5469H30V9.04688H60ZM47.2031 0V22.5H42.7031V0H47.2031Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_24431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvTuvalu);
export default __webpack_public_path__ + "static/media/tv Tuvalu.de2c55179c95554eaa7135a89cb90310.svg";
export { ForwardRef as ReactComponent };